export const queryApi = async (query) => {
  const response = await fetch('/graphql/v1/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(query),
  });

  if (!response.ok) throw new Error('Something wont wrong');

  if (!response) {
    return null;
  }

  return await response.json();
}

export const getQuerySearch = (text) => ({
  query: /* GraphQL */`
    query {
      products(searchInput: {
        text: "${text}"
      }, settingsInput: {
        page: 0,
        limit: 6,
        orderBy: {
          name: relevance,
          type: asc
        }
      }) {
        products {
          id
          name
          versionName
          iconSmall
          icon
          link
          unit {
            name
            sellBy
          }
          price {
            price {
              gross {
                value
                formatted
              }
            }
          }
          sizes {
            availability {
              description
              status
            }
          }
          group {
            name
          }
          awardedParameters {
            id
            name
            values {
              name
            }
          }
          category {
            id
            name
            link
          }
        }
      }
    }
  `
})

export const getQuerySearchBestseller = () => ({
  query: /* GraphQL */`
    query {
      products(searchInput: {
        labels: bestseller
      }, settingsInput: {
        page: 0,
        limit: 6,
        orderBy: {
          name: relevance,
          type: asc
        }
      }) {
        products {
          id
          name
          versionName
          iconSmall
          icon
          link
          unit {
            name
            sellBy
          }
          price {
            price {
              gross {
                value
                formatted
              }
            }
          }
          sizes {
            availability {
              description
              status
            }
          }
          group {
            name
          }
          awardedParameters {
            id
            name
            values {
              name
            }
          }
          category {
            id
            name
            link
          }
        }
      }
    }
  `
})

export const getQueryMenuProduct = (id) => ({
  query: /* GraphQL */`
    query {
      products(searchInput: {
        navigation: ${id}
      }, settingsInput: {
        page: 0,
        limit: 2,
      }, filterInput: {
        availability: inStock
      }) {
        products {
          id
          name
          versionName
          iconSmall
          icon
          link
          unit {
            name
            sellBy
          }
          price {
            price {
              gross {
                value
                formatted
              }
            }
            omnibusPrice {
              gross {
                value
                formatted
              }
            }
            max {
              gross {
                value
                formatted
              }
            }
          }
        }
      }
    }
  `
})